import { useEffect, useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';

import { GetCourses } from '../../services/courses';

import CourseCard from './CourseCard';
import DisableCard from './DisableCard';
import SkeletonCourses from './SkeletonCourses';
import SkeletonDisabledCard from './SkeletonDisabledCard';
import SkeletonTools from './SkeletonTools';
import Tools from './Tools';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontFamily: 'Raleway',
    fontSize: '24px',
    color: theme.palette.text.default,
    fontWeight: '600',
    [theme.breakpoints.between('lg', 'xl')]: {
      margin: theme.spacing(4, 1),
    },
    [theme.breakpoints.up('xl')]: {
      margin: theme.spacing(4, 6),
    },
  },
  titleSkeletor: {
    color: theme.palette.background.card,
    fontWeight: '600',
    margin: theme.spacing(4, 6),
  },
  contentTools: {
    margin: theme.spacing(2, 1),
  },
}));

function Home() {
  const classes = useStyles();
  const [coursesList, setCoursesList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const apiGetCourses = async () => {
    const allCourses = await GetCourses();
    setCoursesList(allCourses.data.sort((a, b) => (a.createdAt - b.createdAt)));
    setIsLoading(false);
  };

  useEffect(() => {
    apiGetCourses();
  }, []);

  const courses = coursesList.map((course) => (course.status === 'enabled' ? (
    <CourseCard
      key={course.id}
      title={course.name}
      shortDescription={course.shortDescription}
      description={course.description}
      topics={course.topics}
      kcoins={course.koins}
      duration={course.duration}
      lessons={course.numLessons}
      id={course.id}
    />
  )
    : (
      <DisableCard
        title={course.name}
        shortDescription={course.description}
        kcoins={course.koins}
        duration={course.duration}
        id={course.id}
      />
    )
  ));
  return (
    <Grid className={classes.container}>
      {' '}
      {isLoading ? (
        <Grid direction="column">
          <Grid item xs={12}>
            <Typography className={classes.titleSkeletor}>
              <Skeleton variant="rectangular" width={140} height={35} />
            </Typography>
          </Grid>
          <Grid container direction="row" xs={12}>
            {[1].map((e) => (
              <SkeletonCourses key={e} />
            ))}
            {[2, 3].map((e) => (
              <SkeletonDisabledCard key={e} />
            ))}
          </Grid>
          <Grid container direction="row" xs={12}>
            {[1, 2, 3].map((m) => (
              <SkeletonTools key={m} />
            ))}
          </Grid>
        </Grid>
      ) : (
        <Grid direction="column">
          <Grid item xs={12}>
            <Typography className={classes.title}>Cursos</Typography>
          </Grid>
          <Grid container direction="row" xs={12}>
            {courses}
          </Grid>
          <Grid container direction="row" xs={12} className={classes.contentTools}>
            <Tools />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

export default Home;
